/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { utils, Contract, ContractFactory } from "ethers";
const _abi = [
    {
        inputs: [],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        inputs: [
            {
                internalType: "int128",
                name: "a",
                type: "int128",
            },
            {
                internalType: "int128",
                name: "b",
                type: "int128",
            },
        ],
        name: "addi128",
        outputs: [
            {
                internalType: "int128",
                name: "c",
                type: "int128",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "int256",
                name: "a",
                type: "int256",
            },
            {
                internalType: "int256",
                name: "b",
                type: "int256",
            },
        ],
        name: "addi256",
        outputs: [
            {
                internalType: "int256",
                name: "c",
                type: "int256",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint128",
                name: "a",
                type: "uint128",
            },
            {
                internalType: "uint128",
                name: "b",
                type: "uint128",
            },
        ],
        name: "addu128",
        outputs: [
            {
                internalType: "uint128",
                name: "c",
                type: "uint128",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "a",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "b",
                type: "uint256",
            },
        ],
        name: "addu256",
        outputs: [
            {
                internalType: "uint256",
                name: "c",
                type: "uint256",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "int128",
                name: "a",
                type: "int128",
            },
        ],
        name: "converti1282u128",
        outputs: [
            {
                internalType: "uint128",
                name: "b",
                type: "uint128",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "int256",
                name: "a",
                type: "int256",
            },
        ],
        name: "converti2562i128",
        outputs: [
            {
                internalType: "int128",
                name: "b",
                type: "int128",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "int256",
                name: "a",
                type: "int256",
            },
        ],
        name: "converti2562u256",
        outputs: [
            {
                internalType: "uint256",
                name: "b",
                type: "uint256",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint128",
                name: "a",
                type: "uint128",
            },
        ],
        name: "convertu1282i128",
        outputs: [
            {
                internalType: "int128",
                name: "b",
                type: "int128",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "a",
                type: "uint256",
            },
        ],
        name: "convertu2562i256",
        outputs: [
            {
                internalType: "int256",
                name: "b",
                type: "int256",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "a",
                type: "uint256",
            },
        ],
        name: "convertu2562u128",
        outputs: [
            {
                internalType: "uint128",
                name: "b",
                type: "uint128",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint128",
                name: "liquidity",
                type: "uint128",
            },
            {
                internalType: "int24",
                name: "leftPt",
                type: "int24",
            },
            {
                internalType: "int24",
                name: "rightPt",
                type: "int24",
            },
            {
                internalType: "bool",
                name: "upper",
                type: "bool",
            },
        ],
        name: "getAmountX",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint128",
                name: "liquidity",
                type: "uint128",
            },
            {
                internalType: "int24",
                name: "leftPt",
                type: "int24",
            },
            {
                internalType: "int24",
                name: "rightPt",
                type: "int24",
            },
            {
                internalType: "bool",
                name: "upper",
                type: "bool",
            },
        ],
        name: "getAmountY",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint128",
                name: "l",
                type: "uint128",
            },
            {
                internalType: "int128",
                name: "delta",
                type: "int128",
            },
        ],
        name: "liquidityAddDelta",
        outputs: [
            {
                internalType: "uint128",
                name: "nl",
                type: "uint128",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "a",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "b",
                type: "uint256",
            },
        ],
        name: "loop",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "int128",
                name: "delta",
                type: "int128",
            },
        ],
        name: "negative",
        outputs: [
            {
                internalType: "uint128",
                name: "",
                type: "uint128",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [],
        name: "sqrtRate_96",
        outputs: [
            {
                internalType: "uint160",
                name: "",
                type: "uint160",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "int128",
                name: "a",
                type: "int128",
            },
            {
                internalType: "int128",
                name: "b",
                type: "int128",
            },
        ],
        name: "subi128",
        outputs: [
            {
                internalType: "int128",
                name: "c",
                type: "int128",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "int256",
                name: "a",
                type: "int256",
            },
            {
                internalType: "int256",
                name: "b",
                type: "int256",
            },
        ],
        name: "subi256",
        outputs: [
            {
                internalType: "int256",
                name: "c",
                type: "int256",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint128",
                name: "a",
                type: "uint128",
            },
            {
                internalType: "uint128",
                name: "b",
                type: "uint128",
            },
        ],
        name: "subu128",
        outputs: [
            {
                internalType: "uint128",
                name: "c",
                type: "uint128",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "a",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "b",
                type: "uint256",
            },
        ],
        name: "subu256",
        outputs: [
            {
                internalType: "uint256",
                name: "c",
                type: "uint256",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [],
        name: "testCalc",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "values",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "int24",
                name: "mapPt",
                type: "int24",
            },
        ],
        name: "wordBitIdx",
        outputs: [
            {
                internalType: "int16",
                name: "wordIdx",
                type: "int16",
            },
            {
                internalType: "uint8",
                name: "bitIdx",
                type: "uint8",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
export class TestCalc__factory extends ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new Contract(address, _abi, signerOrProvider);
    }
}
TestCalc__factory.bytecode = _bytecode;
TestCalc__factory.abi = _abi;
